import { OnInit, OnDestroy, Optional, Inject } from '@angular/core';
import { Component } from '@angular/core';
import { IContextService, PershingTranslationService } from '@pershing/pershing-core';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';
import { ActivatedRoute } from '@angular/router';
declare let dojoApp: any;
@Component({
    selector: 'dojo-balance-details',
    templateUrl: './balance-details.component.html'
})
export class DojoBalanceDetailsComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    subs1: Subscription;
    acctRef: string;
    prevAcctRef: string;
    nxiRestServiceUrl: any;
    nxiRateBoardServiceUrl: any;
    balancesDetailsParams: any;
    balancesDownloadLinkParams: any;
    foreignCurrencyDisplay: any;
    accountGroup: any;
    realTimeActive: any;
    isComponentLoaded: boolean;
    params: any = {};
    entitledForMask: boolean = false;
    entitledForLiabilities: boolean = false;
    liabilities: any;
    isMiddlewareJarBasedApproachEnabledForRateboard: boolean = false;
    constructor(private contextService: IContextService,
                private translationService: PershingTranslationService,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.nxiRestServiceUrl = this.nxiRestService.serviceUrl;
        this.nxiRateBoardServiceUrl = this.nxiRestService.rateboardServiceUrl;
        if (appSettings.ibdConfigMap.hasOwnProperty('isMiddlewareJarBasedApproachEnabledForRateboard')) {
            this.isMiddlewareJarBasedApproachEnabledForRateboard = appSettings.ibdConfigMap.isMiddlewareJarBasedApproachEnabledForRateboard;
        }
    }
    ngOnInit() {
        this.subs1 = this.route.queryParams.subscribe(params => {
            this.params = params ? params : {};
            if (this.subs1) {
                this.subs1.unsubscribe();
            }
        });
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            if (!this.isComponentLoaded || (this.prevAcctRef !== this.acctRef)) {
                this.isComponentLoaded = true;
                this.getBalancesDownload();
                this.prevAcctRef = this.acctRef;
            }
        });
    }

    ngOnDestroy(): void {
        console.log('In dojo Balances destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (this.subs1) {
            this.subs1.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyBalanceCustodyDetail();
            dojoApp.destroyLiabilitiesDetails();
        }
    }
    renderDojoWidget(balancesDojoParams: any, balancesDownloadLinkParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderBalanceCustodyDetail(this.acctRef, balancesDojoParams, balancesDownloadLinkParams);
            // if (this.entitledForLiabilities) {
            //     this.renderLiabilitiesDetails();
            // }
        }
    }
    getBalancesDownload() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'balanceDetails').subscribe(
                resp => {
                    console.log('Retrived common REST Balances params---> : ', resp.response);
                    if (resp.response) {
                        this.foreignCurrencyDisplay = resp.response.foreignCurrencyDisplay;
                        this.accountGroup = resp.response.accountGroup;
                        resp.response.storeUrl = this.nxiRestServiceUrl + resp.response.storeUrl;
                        // resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        console.log('foreignCurrencyDisplay----------->', this.foreignCurrencyDisplay);
                        console.log('accountGroup----------->', this.accountGroup);
                        this.balancesDetailsParams = resp.response;
                        this.entitledForLiabilities = resp.response.entitledForLiabilities ? resp.response.entitledForLiabilities : false;
                        this.entitledForMask = resp.response.entitledForAccountMasking ? resp.response.entitledForAccountMasking : false;
                        this.renderDojoWidget(this.balancesDetailsParams, this.balancesDownloadLinkParams);
                    }
                }
            );
        }
    }
    // renderLiabilitiesDetails() {
    //     let require: any = window['require'];
    //     let comp: any = this;
    //     require(['dojo/ready'], function (ready) {
    //         require(['dojo/dom-construct', 'dojo/dom', 'nxi/widgets/balances/LiabilitiesDetails', 'dijit/dijit'],
    //             function (domConstruct, dom, LiabilitiesDetails, dijit) {
    //                 if (dom.byId('liabilities-details')) {
    //                     domConstruct.destroy(dom.byId('balance-details'));
    //                 }
    //                 if (dijit.byId('liabilities-details')) {
    //                     try {
    //                       dijit.byId('liabilities-details').destroyRecursive();
    //                     } catch (err) {
    //                       console.error('Error while destroying liabilities-details');
    //                     }
    //                   }

    //                 let node = domConstruct.create('div', { id: 'liabilities-details' });
    //                 domConstruct.place(node, dom.byId('liabilities-details-parent'), 'after');

    //                 comp.liabilities = new LiabilitiesDetails({
    //                     expandLiabilities: comp.retiveQueryString('expandLiabilities'),
    //                     expandId: comp.retiveQueryString('expandID'),
    //                     creditFacility: comp.retiveQueryString('creditFacility'),
    //                     entitledForAccountMasking: comp.entitledForMask
    //                 }, 'liabilities-details');
    //                 comp.params = {};
    //             });
    //     });
    // }

    retiveQueryString (field) {
        let href =  window.location.href;
        let reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
        let param = reg.exec(href);
        return param ? param[1] : null;
    }

    openFXRate() {
        if (this.isMiddlewareJarBasedApproachEnabledForRateboard) {
            dojoApp.renderopenFXRate(this.nxiRestServiceUrl +  "/portfolio/fxRate");
        } else {
            dojoApp.renderopenFXRate(this.nxiRateBoardServiceUrl + "/fxRate" );
        }     
    }
}
